var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "45",
        height: "45",
        viewBox: "0 0 38 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0)" } }, [
        _c("path", {
          staticClass: "step-svg-path",
          attrs: {
            d:
              "M5.06654 6.33301C3.66687 6.33301 2.5332 7.46667 2.5332 8.86634V29.133C2.5332 30.5327 3.66687 31.6663 5.06654 31.6663H18.0251C17.8389 30.8506 17.7332 30.0045 17.7332 29.133C17.7332 28.7049 17.7606 28.2831 17.8074 27.8663H6.3332V18.9997L9.23268 16.1002C10.4297 14.9032 12.3701 14.9032 13.5671 16.1002L19.9128 22.4459C21.985 19.5946 25.3383 17.733 29.1332 17.733C31.4778 17.733 33.6552 18.4418 35.4665 19.6553V8.86634C35.4665 7.46667 34.3329 6.33301 32.9332 6.33301H5.06654ZM29.1332 10.133C30.5329 10.133 31.6665 11.2667 31.6665 12.6663C31.6665 14.066 30.5329 15.1997 29.1332 15.1997C27.7335 15.1997 26.5999 14.066 26.5999 12.6663C26.5999 11.2667 27.7335 10.133 29.1332 10.133ZM29.1332 20.2663C24.2363 20.2663 20.2665 24.2361 20.2665 29.133C20.2665 34.0299 24.2363 37.9997 29.1332 37.9997C34.0301 37.9997 37.9999 34.0299 37.9999 29.133C37.9999 24.2361 34.0301 20.2663 29.1332 20.2663ZM29.1332 24.0663C29.8324 24.0663 30.3999 24.6325 30.3999 25.333V27.8663H32.9332C33.6324 27.8663 34.1999 28.4325 34.1999 29.133C34.1999 29.8335 33.6324 30.3997 32.9332 30.3997H30.3999V32.933C30.3999 33.6335 29.8324 34.1997 29.1332 34.1997C28.434 34.1997 27.8665 33.6335 27.8665 32.933V30.3997H25.3332C24.634 30.3997 24.0665 29.8335 24.0665 29.133C24.0665 28.4325 24.634 27.8663 25.3332 27.8663H27.8665V25.333C27.8665 24.6325 28.434 24.0663 29.1332 24.0663Z",
            fill: "currentColor"
          }
        })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0" } }, [
          _c("path", { attrs: { d: "M0 0H38V38H0V0Z", fill: "white" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }